import React, { useEffect, useState, useCallback } from "react";
import Navbar from "../../layouts/Navbar";
import Sidebar from "../../layouts/Sidebar";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import axios from "axios";
import { FaCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import "./Attendance.css";

const Attendance = () => {
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;

  const [attendanceHistory, setAttendanceHistory] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const user_id = localStorage.getItem("userid");

  // Format date YYYY-MM-DD
  const formatDateToLocalYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Fetch attendance
  const getAttendance = useCallback(async () => {
    try {
      const res = await axios.get(`${api}/attendance/my`, {
        headers: { apikey, userid: user_id },
      });
      const data = res.data.data || [];
      setAttendanceHistory(data);
    } catch (err) {
      console.error("Attendance fetch error:", err);
    }
  }, [api, apikey, user_id]);

  useEffect(() => {
    getAttendance();
  }, [getAttendance]);

  // Calendar tile classes
  const tileClassName = ({ date, view }) => {
    if (view !== "month") return null;
    const dateStr = formatDateToLocalYYYYMMDD(date);
    const rec = attendanceHistory.find((item) => item.date === dateStr);
    if (!rec) return null;

    switch (rec.status) {
      case "Present":
        return "attendance-present-day";
      case "Half-Day":
        return "attendance-halfday-day";
      case "Absent":
        return "attendance-absent-day";
      default:
        return null;
    }
  };

  // Calendar tile content
  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;
    const dateStr = formatDateToLocalYYYYMMDD(date);
    const rec = attendanceHistory.find((item) => item.date === dateStr);
    if (!rec) return null;

    return (
      <div
        className="attendance-calendar-tile"
        data-tooltip-id={`tt-${dateStr}`}
        data-tooltip-content={`Status: ${rec.status}`}
      >
        <FaCircle style={{ color: "white", fontSize: "0.8rem" }} />
        <Tooltip id={`tt-${dateStr}`} place="top" />
      </div>
    );
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper d-flex">
        <Sidebar />

        <div
          className="main-panel flex-grow-1"
          style={{
            padding: "2rem",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="attendance-main-panel">
            <h2 className="attendance-page-title">My Attendance</h2>

            <div className="attendance-calendar-wrapper">
              <Calendar
                value={selectedDate}
                onChange={setSelectedDate}
                tileClassName={tileClassName}
                tileContent={tileContent}
              />
            </div>

            <div className="attendance-legend">
              <div className="attendance-legend-item">
                <div className="attendance-present"></div> Present
              </div>
              <div className="attendance-legend-item">
                <div className="attendance-halfday"></div> Halfday
              </div>
              <div className="attendance-legend-item">
                <div className="attendance-absent"></div> Absent
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Attendance;
